import React, { useState, useEffect } from "react";
import TextBoxEntry from "../components/Forms/TextBoxEntry";
import "./EnterFundraiserID.css";
import { FundraiserParticipant } from "../Interfaces/FundraiserRole";

import { useNavigate, useLocation } from "react-router-dom";
import config from "../config";
import { encodeQueryParameter } from "../CommonFunctions";
import fetchWithAuth from "../services/fetchWithAuth";

const BASE_API = config.API_BASE_URL;

const EnterfundraiserID = () => {
  const [fundraiserID, setFundraiserID] = useState("");
  const [participantID, setParticipantID] = useState("");
  const [fundraiserError, setFundraiserError] = useState("");
  const [participantError, setParticipantError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/register-or-shop") {
      // only mount when it's on its own page, not used as a component
      document.title = "Register or Shop";
    }
  }, [location.pathname]);

  const handleRegisterClick = async () => {
    try {
      const response = await fetchWithAuth(
        `${BASE_API}fundraiser/${fundraiserID}/`,
      );

      if (response.status === 404) {
        setFundraiserError(
          "Fundraiser ID not found. Please check and confirm your entry.",
        );
        return;
      }

      if (!response.ok) {
        throw new Error("Network error");
      }
      const data = await response.json();

      if (data) {
        const query_parameter = {
          fundraiser_id: fundraiserID,
        };

        const encoded_string = encodeQueryParameter(query_parameter);

        navigate(`/fundraiser/join-fundraiser/${encoded_string}`, {
          state: { fundraiser_name: data["fundraiser_name"] },
        });
      } else {
        setFundraiserError(
          "Fundraiser ID not found. Please check and confirm your entry",
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFundraiserError("Error fetching data");
    }
  };

  const handleShopNowClick = async () => {
    try {
      const participant_id = Number(participantID.substring(4));
      const url = `${BASE_API}fundraiser-role/${participant_id}/`;
      const response = await fetch(url);

      if (response.status === 404) {
        setParticipantError(
          "Participant ID not found. Please check and confirm your entry.",
        );
        return;
      }

      if (!response.ok) {
        throw new Error("Network error");
      }
      const data: FundraiserParticipant = await response.json();

      if (
        data.participant_code.toLocaleLowerCase() ===
        participantID.toLocaleLowerCase()
      ) {
        navigate(`/participant-shop/part-id/${participantID}`);
      } else {
        setParticipantError(
          "Participant ID not found. Please check and confirm your entry",
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setParticipantError("Error fetching data");
    }
  };

  return (
    <div className="fundraiser-container">
      <h1 className="fundraiser-title">Register Fundraiser or Shop Now</h1>
      <div className="fundraiser-options">
        <div className="textbox-with-error">
          <TextBoxEntry
            header="Shop Now"
            subtext="Enter the ID of the participant you would like to support to start shopping!"
            hintText="Enter participant ID"
            value={participantID}
            onChange={(e) => {
              setParticipantID(e.target.value);
              setParticipantError("");
            }}
            onClick={handleShopNowClick}
          />
          {participantError && (
            <div className="error-message">{participantError}</div>
          )}
        </div>
        <div className="textbox-with-error">
          <TextBoxEntry
            header="Register"
            subtext="Enter your group’s fundraiser ID to register to fundraise/sell"
            hintText="Enter fundraiser ID"
            value={fundraiserID}
            onChange={(e) => {
              setFundraiserID(e.target.value);
              setFundraiserError("");
            }}
            onClick={handleRegisterClick}
          />
          {fundraiserError && (
            <div className="error-message">{fundraiserError}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EnterfundraiserID;
